<script>
import Navbar from "@/components/navbar";
import FooterBG from "@/components/footer-bg";
import FeaturesBG from "@/components/features-bg";

/**
 * Index-1 component
 */
export default {
  components: {
    Navbar,
    FeaturesBG,
    // Services,
    // About,
    // Pricing,
    // Testimonial,
    // GetStarted,
    // Blog,
    // Contact,
    FooterBG,
  },
  methods: {
    /**
     * Toggle menu
     */
    toggleMenu() {
      document.getElementById("navbarCollapse").classList.toggle("show");
    }
  }
};
</script>
<template>
  <div>
    <Navbar />

    <div v-scroll-spy>
      <!--START HOME-->
      <section
        class="section bg-home height-100vh"
        id="home"
        :style="{'background-image': 'url(' + require('@/assets/images/fanmath-images/background.jpg') + ')', 'background-size': 'cover','background-position': 'center' }"
      >
<div class="bg-overlay"></div>
        <div class>
          <div class>
            <div class="container slidero">
              <div class="row">
                <div class="col-lg-8 offset-lg-2 text-white text-center">
                  <h1 class="home-title">FANMATH</h1>
                  <h4 class="home-small-title"></h4>
                  <p
                    class="padding-t-15 home-desc mx-auto"
                  ></p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- Particles -->
        <!-- <vue-particles class="position-relative" color="#FFF"></vue-particles> -->

      </section>


     

      <FeaturesBG />
      <!-- <Services /> -->
      <!-- <About /> -->
      <!-- <Pricing /> -->
      <!-- <Testimonial /> -->
      <!-- <GetStarted /> -->
      <!-- <Blog /> -->
      <!-- <Contact /> -->
      <FooterBG />
    </div>
  </div>
</template>

<style scoped>
.home-title
{
  color: orange;
}
.home-small-title
{
  color: rgb(223, 158, 39);
}
.home-desc
{
  color: rgb(238, 173, 52);
}
::v-deep .modal-content {
  background-color: #000000;
  color: white;
  background: none;
  border: none;
}
::v-deep .modal-header {
  border: none;
}
::v-deep .modal-backdrop {
  opacity: 0.5;
}
html{
   height: 100%;
   overflow-y: hidden;
}
</style>